import clsx from 'clsx'
import React, { ReactNode } from 'react'
import {
  Control,
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form'

import s from './styles.module.scss'

import ControlledSelectField from '../select-field/ControlledSelectField'
import { ISelectFieldProps } from '../select-field/SelectField'
import { ArrayElement } from '../../../types'

export type HourPickerOptionsProps = {
  label: `${string}:${string}`
  value: `${string}:${string}` | null
}[]

const DEFAULT_EMPTY_HOUR_PICKER_OPTION: ArrayElement<HourPickerOptionsProps> = {
  label: '--:--',
  value: null,
}
// eslint-disable-next-line react-refresh/only-export-components
export const DEFAULT_MIDNIGHT_HOUR_PICKER_OPTION: ArrayElement<HourPickerOptionsProps> =
  {
    label: '00:00',
    value: '00:00',
  }

// eslint-disable-next-line react-refresh/only-export-components
export const DEFAULT_HOUR_PICKER_OPTIONS: HourPickerOptionsProps = [
  DEFAULT_EMPTY_HOUR_PICKER_OPTION,
  DEFAULT_MIDNIGHT_HOUR_PICKER_OPTION,
  { label: '01:00', value: '01:00' },
  { label: '02:00', value: '02:00' },
  { label: '03:00', value: '03:00' },
  { label: '04:00', value: '04:00' },
  { label: '05:00', value: '05:00' },
  { label: '06:00', value: '06:00' },
  { label: '07:00', value: '07:00' },
  { label: '08:00', value: '08:00' },
  { label: '09:00', value: '09:00' },
  { label: '10:00', value: '10:00' },
  { label: '11:00', value: '11:00' },
  { label: '12:00', value: '12:00' },
  { label: '13:00', value: '13:00' },
  { label: '14:00', value: '14:00' },
  { label: '15:00', value: '15:00' },
  { label: '16:00', value: '16:00' },
  { label: '17:00', value: '17:00' },
  { label: '18:00', value: '18:00' },
  { label: '19:00', value: '19:00' },
  { label: '20:00', value: '20:00' },
  { label: '21:00', value: '21:00' },
  { label: '22:00', value: '22:00' },
  { label: '23:00', value: '23:00' },
]

type ControlledHourPickerProps<T extends FieldValues> = Pick<
  ISelectFieldProps,
  'menuStyle' | 'placeholder'
> &
  Omit<UseControllerProps<T>, 'shouldUnregister' | 'control'> & {
    label: string | ReactNode
    control: Control<T>
    disabled?: boolean
    fullWidth?: true
    column?: true
    hoursOptions?: HourPickerOptionsProps | null
  }
export const ControlledHourPicker = <T extends FieldValues>(
  props: ControlledHourPickerProps<T>,
) => {
  const { disabled, fullWidth, column, hoursOptions, ...fieldProps } = props

  const { fieldState } = useController(fieldProps)

  const errorMessage = fieldState.error?.message

  return (
    <div className={clsx(s.container, { [s.fullWidth]: fullWidth })}>
      <ControlledSelectField
        {...fieldProps}
        rules={fieldProps.rules ?? {}}
        options={
          hoursOptions
            ? [DEFAULT_EMPTY_HOUR_PICKER_OPTION, ...hoursOptions]
            : DEFAULT_HOUR_PICKER_OPTIONS
        }
        labelClassName={s.title}
        disabled={disabled}
        inline={!column}
        fullWidth={fullWidth}
        menuStyle={{ maxHeight: '140px' }}
        {...(column && { containerClassName: s.column })}
      />

      {errorMessage ? (
        <span className={s.errorMessage}>{errorMessage}</span>
      ) : null}
    </div>
  )
}
